import * as THREE from 'three';
import { ClosedSplineCurve } from './ClosedSplineCurve';
import {Line2} from './Line2';

export class CurveEditor2 {
    static innerEach = 15; // 每一段曲线，它们内部的插入点数。也就是两个控制点之间的插入点数
    static boxSize = 10; // 控制点的盒子的宽度
    static boxSizeHalf = CurveEditor2.boxSize / 2; // 盒子宽度的一半
    static hoverBoxSize = 12; // 鼠标移到控制点上方，盒子的宽度
    static hoverBoxSizeHalf = CurveEditor2.hoverBoxSize / 2; // 上述宽度的一半
    // 三个符号，分别表示鼠标位于点上、曲线上以及空白处
    static POINT = Symbol();
    static LINE = Symbol();
    static NONE = Symbol();

    // 下面这些是重要的配置，这样就可以用一个类为多种曲线提供支持。
    // 标记曲线是否可以被鼠标选中。锁住曲线。如果为true，那么曲线就无法点击了。这对于正多边形的瓶口样式是有用的。
    lockLine = false;
    // 是否限定最大的x值为60
    lockMaxX = true;
    // 曲线是否是闭合的。瓶身曲线，这个值为false，而瓶口曲线，对于第三种任意曲线，这个值为true
    curveClose = false;
    // 是否让控制点关于x轴对称
    xMirror = false;
    // 是直线还是是曲线
    isLine = false;

    // 运行时用到的一些变量
    // 鼠标当前位置
    mouse_pos = new THREE.Vector2();
    // 鼠标落在什么位置，可能是控制点、曲线，或者空白处
    mouse_hit = {};
    // 鼠标拖动时的初始位置
    start_drag_pos = new THREE.Vector2();
    // 鼠标拖动的对象
    drag_target_index = -1;
    // 拖动对象的初始位置
    drag_target_start_pos = new THREE.Vector2();
    // 鼠标拖动的对象
    drag_vector = new THREE.Vector2();

    BOX_SIZE = 15;

    constructor(canvas, controlPoints, xMirror) {
        this.canvas = canvas;
        this.context = canvas.getContext("2d");
        this.updateSize();
        if (xMirror !== undefined) this.xMirror = xMirror;

        // 控制点
        this.controlPoints = controlPoints || [
            new THREE.Vector2(0, -200),
            new THREE.Vector2(36, -150),
            new THREE.Vector2(-8, 0),
            new THREE.Vector2(-50, 150),
            new THREE.Vector2(0, 200),
        ];
        this.updatePoints();

        // const editor = this;
        // this.canvas.addEventListener("mousedown", function (e) {
        //     if (e.button !== 0) return;

        //     if (!editor.checkDbClick()) {
        //         if (editor.mouse_hit.type === CurveEditor2.POINT) {
        //             editor.startDrag();
        //         }
        //     }
        //     editor.draw();
        // });
        // this.canvas.addEventListener("mousemove", function (e) {
        //     let x = e.clientX - editor.bound.left;
        //     let y = e.clientY - editor.bound.top;
        //     editor.mouse_pos.x = x - editor.centerX;
        //     editor.mouse_pos.y = y - editor.centerY;

        //     if (editor.drag_target_index >= 0) {
        //         editor.doDrag();
        //     } else {
        //         editor.hitTest();
        //     }
        //     editor.draw();
        // });
        // this.canvas.addEventListener("mouseup", function (e) {
        //     if (e.button !== 0) return;

        //     if (editor.drag_target_index >= 0) {
        //         editor.endDrag();
        //     }
        //     editor.draw();
        // });
        // this.canvas.addEventListener("click", function(e) {
        //     e.preventDefault();
        //     e.stopPropagation();
        // });




        const editor = this;
        this.canvas.addEventListener("touchstart", function (e) {
            //  e.stopPropagation();
            // e.preventDefault();
            let bound = canvas.getBoundingClientRect();
            let x = e.changedTouches[0].clientX - bound.left;
            let y = e.changedTouches[0].clientY - bound.top;
            editor.mouse_pos.x = x - editor.centerX;
            editor.mouse_pos.y = y - editor.centerY;

            editor.hitTest();

            if (editor.mouse_hit.type === CurveEditor2.POINT && editor.mouse_hit.index >= 0) {
                editor.startDrag();
            }
            editor.draw();
        });
        this.canvas.addEventListener("touchmove", function (e) {
            // e.stopPropagation();
            // e.preventDefault();
            // console.log("touchmove");
            let bound = canvas.getBoundingClientRect();
            let x = e.changedTouches[0].clientX - bound.left;
            let y = e.changedTouches[0].clientY - bound.top;
            editor.mouse_pos.x = x - editor.centerX;
            editor.mouse_pos.y = y - editor.centerY;

            editor.error = false;
            if (editor.drag_target_index >= 0) {
                editor.doDrag();
                try {
                    if (editor.onCurveChange) {
                        editor.onCurveChange();
                    }
                } catch (e) {
                    editor.error = true;
                }
                editor.draw();
            }

        });
        this.canvas.addEventListener("touchend", function (e) {
            // e.stopPropagation();
            // e.preventDefault();
            // console.log("touch end");
            if (editor.drag_target_index >= 0) {
                editor.endDrag();
            }
            editor.draw();
        });

        this.draw();
    }

    updatePoints() {
        // 直线不需要更新点
        if (this.isLine) return;

        let controlPoints = this.controlPoints;
        if (this.curveClose) {
            let curve = new ClosedSplineCurve(controlPoints);
            let totalPoints = (CurveEditor2.innerEach + 1) * controlPoints.length;
            this.points = curve.getPoints(totalPoints);
        } else {
            let curve = new THREE.SplineCurve(controlPoints);
            let totalPoints = (CurveEditor2.innerEach + 1) * (controlPoints.length - 1);
            this.points = curve.getPoints(totalPoints);
        }
    }

    // 如果窗口的尺寸发生变化，那么就需要重新设置画布的尺寸
    updateSize() {
        let parentNode = this.canvas.parentNode;
        this.bound = parentNode.getBoundingClientRect();
        let width = Math.floor(this.bound.width);
        let height = Math.floor(this.bound.height);
        this.canvas.style.width = width + "px";
        this.canvas.style.height = height + "px";
        this.canvas.width = width;
        this.canvas.height = height;
        this.width = this.canvas.width;
        this.height = this.canvas.height;
        this.centerX = Math.round(this.width / 2);
        this.centerY = Math.round(this.height / 2);
        // console.log(this.centerX, this.centerY);
        // 设置画布的变换，这样就不用每次都给点加上中心偏移了。
        this.context.setTransform(1, 0, 0, 1, this.centerX + 0.5, this.centerY + 0.5);
    }

    onCurveChanged(handler) {
        this.onCurveChange = handler;
    }

    getCurve() {
        return this.curveClose ? new ClosedSplineCurve(this.controlPoints) : new THREE.SplineCurve(this.controlPoints);
    }

    checkDbClick() {
        const dbClickPeroid = 500;
        let now = Date.now();
        if (now - this.lastClickTime < dbClickPeroid) {
            this.lastClickTime = 0;
            this.onDbClick();
            return true;
        } else {
            this.lastClickTime = now;
        }
        return false;
    }

    onDbClick() {
        // console.log("xxx");
        if (this.mouse_hit.type === CurveEditor2.POINT) {
            this.controlPoints.splice(this.mouse_hit.index, 1);
            this.updatePoints();
        } else if (this.mouse_hit.type === CurveEditor2.LINE) {
            let point = this.mouse_hit.point;
            this.controlPoints.splice(this.mouse_hit.index + 1, 0, point);
            this.updatePoints();
        }
    }

    startDrag() {
        this.drag_target_index = this.mouse_hit.index;
        this.start_drag_pos.copy(this.mouse_pos);
        this.drag_target_start_pos.copy(this.controlPoints[this.drag_target_index]);
    }

    doDrag() {
        this.drag_vector.subVectors(this.mouse_pos, this.start_drag_pos);
        this.controlPoints[this.drag_target_index].addVectors(this.drag_target_start_pos, this.drag_vector);
        if (this.lockMaxX) {
            this.controlPoints[this.drag_target_index].x = Math.min(60 - 2, this.controlPoints[this.drag_target_index].x);
        }

        if (this.xMirror) {
            if (this.drag_target_index == 2) {
                this.controlPoints[this.drag_target_index].y = 0;
            } else {
                this.controlPoints[4 - this.drag_target_index].set(
                    this.controlPoints[this.drag_target_index].x,
                    -this.controlPoints[this.drag_target_index].y
                );
            }
        }

        this.updatePoints();

        if (this.onCurveChange) {
            this.onCurveChange();
        }
    }

    endDrag() {
        this.drag_target_index = -1;
        this.mouse_hit.type = CurveEditor2.NONE;
        if (this.onCurveChangeDown) { this.onCurveChangeDown(); }
        // console.log(this.controlPoints);
    }

    getControlPoints() {
        return this.controlPoints.map(p => p.clone());
    }

    setOnCurveChangeDown(handler) {
        this.onCurveChangeDown = handler;
    }

    incControlPoint() {
        let curve = this.getCurve();
        let cnt = this.controlPoints.length + 1;
        let newPoints = curve.getPoints(cnt);
        // console.log("newPoints", newPoints);
        this.controlPoints = newPoints;
    }

    redControlPoint() {
        let curve = this.getCurve();
        let cnt = this.controlPoints.length - 1;
        let newPoints = curve.getPoints(cnt);
        // console.log("newPoints", newPoints);
        // this.setVaseContent(newPoints);
        this.controlPoints = newPoints;
    }

    // redControlPoint() {        
    //     let curve = this.getCurve();
    //     let cnt = (this.controlPoints.length - 1) * 2 - 1;
    //     let newPoints = curve.getPoints(cnt);
    //     let newPoints2 = [];
    //     for (let i = 0; i < newPoints.length; i += 2) {
    //         newPoints2.push(newPoints[i]);
    //     }
    //     console.log("newPoints2", newPoints2);
    //     this.controlPoints = newPoints2;
    // }

    // setVaseContent(controlPoints) {
    //     this.controlPointsOrigin = controlPoints;
    //     this.controlPoints = this.controlPointsOrigin.map(p => p.clone().multiplyScalar(this.scale));
    //     this.draw();
    // }

    // 鼠标击中测试
    hitTest() {
        const boxSizeHalf = CurveEditor2.boxSizeHalf;
        let x = this.mouse_pos.x;
        let y = this.mouse_pos.y;


        // let center = this.mouse_pos;
        // let radius = this.BOX_SIZE;
        // this.mouse_hit_index = this.controlPoints.findIndex(p => p.distanceTo(center) <= radius);

        // 判断是否击中控制点
        let mouse_pos = this.mouse_pos;
        const BOX_SIZE = this.BOX_SIZE;
        let point_index = this.controlPoints.findIndex(p => p.distanceTo(mouse_pos) <= BOX_SIZE);
        // let point_index = this.controlPoints.findIndex(p => x >= p.x - boxSizeHalf && x <= p.x + boxSizeHalf && y >= p.y - boxSizeHalf && y <= p.y + boxSizeHalf);
        if (point_index >= 0) {
            this.mouse_hit.type = CurveEditor2.POINT;
            this.mouse_hit.index = point_index;
            return;
        }

        // 判断是否击中曲线
        if (this.lockLine) {
            // 不判断
            this.mouse_hit.type = CurveEditor2.NONE;
            return;
        }

        if (this.isLine) {
            // 直线
            let line = new Line2();
            let nearestPoint = new THREE.Vector2();
            for (let i = 0; i < this.controlPoints.length - 1; i++) {
                line.set(this.controlPoints[i], this.controlPoints[i + 1]).closestPointToPoint(this.mouse_pos, true, nearestPoint);
                if (nearestPoint.distanceTo(this.mouse_pos) <= 3) {
                    this.mouse_hit.type = CurveEditor2.LINE;
                    this.mouse_hit.index = i;
                    this.mouse_hit.point = nearestPoint; // 记录最近点（位于曲线上），以便双击时可以新增点。
                    return;
                }
            }

            if (this.curveClose) {
                let i = this.controlPoints.length - 1;
                line.set(this.controlPoints[i], this.controlPoints[0]).closestPointToPoint(this.mouse_pos, true, nearestPoint);
                if (nearestPoint.distanceTo(this.mouse_pos) <= 3) {
                    this.mouse_hit.type = CurveEditor2.LINE;
                    this.mouse_hit.index = i;
                    this.mouse_hit.point = nearestPoint; // 记录最近点（位于曲线上），以便双击时可以新增点。
                    return;
                }
            }
        } else {
            // 曲线
            const innerEach = CurveEditor2.innerEach;
            let line = new Line2();
            let nearestPoint = new THREE.Vector2();
            for (let i = 0; i < this.controlPoints.length - 1; i++) {
                let j = i * (innerEach + 1);
                let k = j + innerEach + 1;
                for (let l = j; l < k; l++) {
                    line.set(this.points[l], this.points[l + 1]).closestPointToPoint(this.mouse_pos, true, nearestPoint);
                    if (nearestPoint.distanceTo(this.mouse_pos) <= 3) {
                        this.mouse_hit.type = CurveEditor2.LINE;
                        this.mouse_hit.index = i;
                        this.mouse_hit.point = nearestPoint; // 记录最近点（位于曲线上），以便双击时可以新增点。
                        return;
                    }
                }
            }

            if (this.curveClose) {
                let i = this.controlPoints.length - 1;
                let j = i * (innerEach + 1);
                let k = j + innerEach + 1;
                let l2 = 0;
                for (let l = j; l < k; l++) {
                    l2 = l === k - 1 ? 0 : l + 1;
                    line.set(this.points[l], this.points[l2]).closestPointToPoint(this.mouse_pos, true, nearestPoint);
                    if (nearestPoint.distanceTo(this.mouse_pos) <= 3) {
                        this.mouse_hit.type = CurveEditor2.LINE;
                        this.mouse_hit.index = i;
                        this.mouse_hit.point = nearestPoint; // 记录最近点（位于曲线上），以便双击时可以新增点。
                        return;
                    }
                }
            }
        }

        this.mouse_hit.type = CurveEditor2.NONE;
    }

    draw() {
        this.clear();
        if (this.lockMaxX) {
            this.drawMesh();
            this.drawCutLine();
        } else {
            this.drawMesh2();
            this.drawAxes();
        }
        this.drawControlPoints();
        this.drawCurve();
    }

    clear() {
        this.context.clearRect(-this.centerX - 1, -this.centerY - 1, this.width + 2, this.height + 2);
    }

    drawMesh() {
        const cubeSize = 30;
        this.context.beginPath();
        let x = 0;
        while (x > -this.centerX) {
            this.context.moveTo(x, -this.centerY);
            this.context.lineTo(x, this.centerY);
            x -= cubeSize;
        }
        x = cubeSize;
        while (x < this.centerX) {
            this.context.moveTo(x, -this.centerY);
            this.context.lineTo(x, this.centerY);
            x += cubeSize;
        }
        let y = 0;
        while (y > -this.centerY) {
            this.context.moveTo(-this.centerX, y);
            this.context.lineTo(this.centerX, y);
            y -= cubeSize;
        }
        y = cubeSize;
        while (y < this.centerY) {
            this.context.moveTo(-this.centerX, y);
            this.context.lineTo(this.centerX, y);
            y += cubeSize;
        }
        this.context.closePath();
        this.context.lineWidth = 1;
        this.context.strokeStyle = "#ccc";
        this.context.stroke();
    }

    drawMesh2() {
        const cubeSize = 30;
        this.context.beginPath();
        let x = -cubeSize;
        while (x > -this.centerX) {
            this.context.moveTo(x, -this.centerY);
            this.context.lineTo(x, this.centerY);
            x -= cubeSize;
        }
        x = cubeSize;
        while (x < this.centerX) {
            this.context.moveTo(x, -this.centerY);
            this.context.lineTo(x, this.centerY);
            x += cubeSize;
        }
        let y = -cubeSize;
        while (y > -this.centerY) {
            this.context.moveTo(-this.centerX, y);
            this.context.lineTo(this.centerX, y);
            y -= cubeSize;
        }
        y = cubeSize;
        while (y < this.centerY) {
            this.context.moveTo(-this.centerX, y);
            this.context.lineTo(this.centerX, y);
            y += cubeSize;
        }
        this.context.closePath();
        this.context.lineWidth = 1;
        this.context.strokeStyle = "#ccc";
        this.context.stroke();
    }

    drawAxes() {
        this.context.beginPath();
        this.context.moveTo(0, -this.centerY);
        this.context.lineTo(0, this.centerY);
        this.context.moveTo(-this.centerX, 0);
        this.context.lineTo(this.centerX, 0);
        this.context.closePath();
        this.context.lineWidth = 1;
        this.context.strokeStyle = "#000";
        this.context.stroke();
    }

    drawCutLine() {
        let x = 60;
        this.context.beginPath();
        this.context.moveTo(x, -this.centerY);
        this.context.lineTo(x, this.centerY);
        this.context.closePath();
        this.context.lineWidth = 2;
        this.context.strokeStyle = "#ff0000";
        this.context.stroke();
    }

    drawControlPoints() {

        const boxSize = this.BOX_SIZE;
        this.context.fillStyle = "#05A8F3";

        for (let i = 0; i < this.controlPoints.length; i++) {
            if (!(this.mouse_hit.type === CurveEditor2.POINT && i === this.mouse_hit.index)) {
                let p = this.controlPoints[i];
                this.context.beginPath();
                this.context.arc(p.x, p.y, boxSize, 0, 2 * Math.PI);
                this.context.closePath();
                this.context.fillStyle = "#05A8F3";
                this.context.shadowBlur = 25;
                this.context.shadowColor = "rgba(155, 204, 253, 1)"; // 阴影颜色
                this.context.shadowBlur = 7.5; // 阴影模糊范围
                this.context.fill();
                // this.context.fillRect(centerX + p.x - boxSizeHalf, centerY + p.y - boxSizeHalf, boxSize, boxSize);
            } else {
                let p = this.controlPoints[i];
                this.context.lineWidth = 1;

                this.context.shadowColor = "rgba(100, 100, 100, 0)";

                this.context.strokeStyle = "#FFF";
                this.context.beginPath();
                this.context.arc(p.x, p.y, boxSize + 5, 0, 2 * Math.PI);
                this.context.closePath();
                this.context.fillStyle = "#FFF";
                this.context.shadowBlur = 25;
                this.context.shadowColor = "rgba(229, 229, 229, 1)";
                this.context.shadowBlur = 7.5; // 阴影模糊范围
                this.context.fill();
                this.context.shadowColor = "rgba(100, 100, 100, 0)";

                this.context.strokeStyle = "#04A9F3";
                this.context.beginPath();
                this.context.arc(p.x, p.y, boxSize, 0, 2 * Math.PI);
                this.context.closePath();
                this.context.fillStyle = "#04A9F3";
                this.context.fill();

                // this.context.fillStyle = "red";
                // this.context.fillRect(p.x - CurveEditor2.boxSizeHalf, p.y - CurveEditor2.boxSizeHalf, CurveEditor2.boxSize, CurveEditor2.boxSize);
            }
        }

        this.context.shadowColor = "rgba(100, 100, 100, 0)";

        // this.controlPoints.forEach((p, i) => {
        //     if (this.mouse_hit.type === CurveEditor2.POINT && i === this.mouse_hit.index) {
        //         this.context.strokeStyle = "red";
        //         this.context.strokeRect(p.x - CurveEditor2.hoverBoxSizeHalf, p.y - CurveEditor2.hoverBoxSizeHalf, CurveEditor2.hoverBoxSize, CurveEditor2.hoverBoxSize);
        //     } else {
        //         this.context.fillStyle = "red";
        //         this.context.fillRect(p.x - CurveEditor2.boxSizeHalf, p.y - CurveEditor2.boxSizeHalf, CurveEditor2.boxSize, CurveEditor2.boxSize);
        //     }
        // });
    }

    drawCurve() {
        const controlPoints = this.controlPoints;
        if (this.isLine) {
            // 直线：把各个控制点连接起来
            this.context.lineCap = 'round';
            for (let i = 0; i < controlPoints.length - 1; i++) {
                // let points = curve.getPoints(50);
                // this.context.strokeStyle = "#2F3B4B";
                // this.context.lineWidth = 5;
                // this.context.beginPath();
                // this.context.moveTo(points[0].x, points[0].y);
                // for (let i = 1; i < points.length; i++) {
                //     this.context.lineTo(points[i].x, points[i].y);
                // }
                // this.context.lineCap = 'round';
                // this.context.stroke();
                // this.context.closePath();

                if (this.mouse_hit.type === CurveEditor2.LINE && this.mouse_hit.index === i) {
                    this.context.strokeStyle = "#2F3B4B";
                    this.context.lineWidth = 5;
                } else {
                    this.context.strokeStyle = "#2F3B4B";
                    this.context.lineWidth = 5;
                }
                this.context.beginPath();
                this.context.moveTo(controlPoints[i].x, controlPoints[i].y);
                this.context.lineTo(controlPoints[i + 1].x, controlPoints[i + 1].y);
                this.context.stroke();
                this.context.closePath();
            }
            // 闭合：返回开头
            if (this.curveClose) {
                let i = controlPoints.length - 1;
                if (this.mouse_hit.type === CurveEditor2.LINE && this.mouse_hit.index === i) {
                    this.context.strokeStyle = "#2F3B4B";
                    this.context.lineWidth = 5;
                } else {
                    this.context.strokeStyle = "#2F3B4B";
                    this.context.lineWidth = 5;
                }
                this.context.beginPath();
                this.context.moveTo(controlPoints[i].x, controlPoints[i].y);
                this.context.lineTo(controlPoints[0].x, controlPoints[0].y);
                this.context.stroke();
                this.context.closePath();
            }
        } else {
            const innerEach = CurveEditor2.innerEach;
            const points = this.points;
            for (let i = 0; i < controlPoints.length - 1; i++) {
                let j = i * (innerEach + 1);
                let k = j + innerEach + 2;
                if (this.mouse_hit.type === CurveEditor2.LINE && this.mouse_hit.index === i) {                  
                    this.context.strokeStyle = "#2F3B4B";
                    this.context.lineWidth = 5;
                } else {
                    this.context.strokeStyle = "#2F3B4B";
                    this.context.lineWidth = 5;
                }
                this.context.beginPath();
                this.context.moveTo(points[j].x, points[j].y);
                for (let l = j + 1; l < k; l++) {
                    this.context.lineTo(points[l].x, points[l].y);
                }
                this.context.lineCap = 'round';
                this.context.stroke();
                this.context.closePath();
            }
            if (this.curveClose) {
                let i = controlPoints.length - 1;
                if (this.mouse_hit.type === CurveEditor2.LINE && this.mouse_hit.index === i) {                   
                    this.context.strokeStyle = "#2F3B4B";
                    this.context.lineWidth = 5;
                } else {
                    this.context.strokeStyle = "#2F3B4B";
                    this.context.lineWidth = 5;
                }
                this.context.beginPath();
                let j = i * (innerEach + 1);
                this.context.moveTo(points[j].x, points[j].y);
                let k = j + innerEach + 1;
                for (let l = j + 1; l < k; l++) {
                    this.context.lineTo(points[l].x, points[l].y);
                }
                this.context.lineTo(points[0].x, points[0].y);
                this.context.lineCap = 'round';
                this.context.stroke();
                this.context.closePath();
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/views/reliefVase/scripts/CurveEditor2.js